// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3SRZ6","remove":"File_remove__36PNl"};